import { CasinoTypeButton } from '@/components/casino/lobby/CasinoTypeButton'
import { P2pActivity } from '@/components/p2p/detail/P2pActivity'
import { P2pOptionSectionHeader } from '@/components/p2p/detail/P2pOptionSectionHeader'
import { P2pTopHolders } from '@/components/p2p/detail/P2pTopHolders'
import { P2P_DETAIL_TAB_HOLDERS, P2P_DETAIL_TABS } from '@/config/p2p'
import { getSelectedP2pOption } from '@/lib/p2p'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { selectP2pActiveTab, selectSelectedP2pOptionId, setP2pMarketDetailTab } from '@/store/slices/p2pSlice'
import type { P2PMarket } from '@/types/p2p'

interface P2pMarketTabsProps {
	market: P2PMarket
}

export function P2pMarketTabs({ market }: P2pMarketTabsProps) {
	const dispatch = useAppDispatch()
	const activeTab = useAppSelector(selectP2pActiveTab)
	const selectedOptionId = useAppSelector(selectSelectedP2pOptionId)
	const selectedOption = getSelectedP2pOption(market, selectedOptionId)

	if (!selectedOption || !market) {
		return null
	}

	return (
		<div className='w-full'>
			<div className='mb-5 flex w-fit items-center gap-2'>
				{P2P_DETAIL_TABS.map((tab) => (
					<CasinoTypeButton key={tab.id} label={tab.label} icon={tab.icon} isActive={activeTab === tab.id} onClick={() => dispatch(setP2pMarketDetailTab(tab.id))} />
				))}
			</div>

			<div className='w-full overflow-hidden rounded-2xl border border-border bg-card shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
				<div className='border-b border-border px-4 py-4 sm:px-5'>
					<P2pOptionSectionHeader option={selectedOption} market={market} />
				</div>

				<div className='p-4 sm:p-5'>
					{activeTab === P2P_DETAIL_TAB_HOLDERS ? (
						<P2pTopHolders marketId={market.id} optionId={selectedOption.id} />
					) : (
						<P2pActivity marketId={market.id} optionId={selectedOption.id} />
					)}
				</div>
			</div>
		</div>
	)
}
